import React from 'react';
import config from '@plone/registry';

const Skeleton = ({ isEditMode, title }) => {
  const Container = config.getComponent('Container').component || 'div';

  return (
    <Container className="px-4">
      <div className="skeleton-template">
        {title && (
          <div>
            <div>
              <h2 className="mb-4">{title}</h2>
            </div>
          </div>
        )}
        <div className="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal card-teaser-block-3 mb-3">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <div className="align-items-top rounded shadow" key={i}>
              <div className="pb-5"></div>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default Skeleton;
